export default (callSign: string) => {
  const snippet =
    `ra("${callSign}", {
      audio: {
        id: 'player'
      },
    });`;

  return snippet;
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/content/radioAnalytics/snippets/audioVideoSnippet.js